module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"wrapper\">\n<div class=\"liveCol\">\n<%\nvar aPS = ((model.adminPreviewSubscribers || {}).data || []);\nvar aPSCnt = aPS.length;\nif (aPSCnt) {\n%>\n<p>Wählen Sie einen Empfänger und einen Vorschau-Modus:</p>\n<div class=\"previewModes\">\n<select name=\"adminPreviewSubscriber\">\n<%\nvar grantedMailingListIDs = model.grantedMailingListIDs || {};\nvar i, subscriber, ml, list = {};\nfor (i=0; i<aPSCnt; i++) {\nsubscriber = (aPS[i] || {}).attributes || {};\nif (!list[subscriber.mailingListID]) list[subscriber.mailingListID] = { name: subscriber.mailingListName, subscribers: [] };\nlist[subscriber.mailingListID].subscribers.push(subscriber);\n}\nvar mailingListID, j, currentMailingListID = 0;\nfor (mailingListID in list) {\n// different mailing-list\nif (currentMailingListID != mailingListID) {\nif (currentMailingListID != 0) {\n%>\t\t\t\t\t\t\t\t</optgroup>\n<%\t\t\t\t\t\t\t}\n%>\t\t\t\t\t\t\t<optgroup label=\"Mailingliste &quot;<%= list[mailingListID].name %>&quot;\">\n<%\t\t\t\t\t\t\tcurrentMailingListID = mailingListID;\n}\nfor(j in (list[mailingListID] || {}).subscribers || []) {\nsubscriber = list[mailingListID].subscribers[j];\n%>\t\t\t\t\t\t\t<option value=\"<%= subscriber.subscriberID %>\"><%= subscriber.lastName %> <%= subscriber.firstName %> (<%= subscriber.email %>)</option>\n<%\t\t\t\t\t\t}\n}\nif (currentMailingListID>0) {\n%>\t\t\t\t\t\t</optgroup>\n<%\t\t\t\t\t} %>\n</select>\n<select name=\"viewMode\">\n<option value=\"html\" selected>HTML-Version</option>\n<option value=\"text\">Text-Version</option>\n</select>\n<button type=\"button\" data-action=\"showMailing\" data-type=\"desktop\" data-target=\"iframe\">Desktop</button>\n<button type=\"button\" data-action=\"showMailing\" data-type=\"external\" data-target=\"window\">Neues Fenster / Tab</button>\n<button type=\"button\" data-action=\"showMailing\" data-type=\"downloadHtml\">Download Html</button>\n<button type=\"button\" data-action=\"sendMailing\" data-type=\"sendPreviewMail\">Vorschau E-Mail senden</button>\n</div>\n<%\t}\nelse {\n%>\t\t\t<p>Es wurden noch keine Empfänger für den Vorschau-Modus definiert!</p>\n<%\t}\n%>\n</div>\n</div>\n<iframe class=\"desktop\" frameborder=\"0\"></iframe>\n</div>"
  , __filename = "components/templates/newsletter/mailings/edit/preview/preview.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"wrapper\">\n<div class=\"liveCol\">\n")
    ; __line = 4
    ; 
var aPS = ((model.adminPreviewSubscribers || {}).data || []);
var aPSCnt = aPS.length;
if (aPSCnt) {

    ; __line = 8
    ; __append("\n<p>Wählen Sie einen Empfänger und einen Vorschau-Modus:</p>\n<div class=\"previewModes\">\n<select name=\"adminPreviewSubscriber\">\n")
    ; __line = 12
    ; 
var grantedMailingListIDs = model.grantedMailingListIDs || {};
var i, subscriber, ml, list = {};
for (i=0; i<aPSCnt; i++) {
subscriber = (aPS[i] || {}).attributes || {};
if (!list[subscriber.mailingListID]) list[subscriber.mailingListID] = { name: subscriber.mailingListName, subscribers: [] };
list[subscriber.mailingListID].subscribers.push(subscriber);
}
var mailingListID, j, currentMailingListID = 0;
for (mailingListID in list) {
// different mailing-list
if (currentMailingListID != mailingListID) {
if (currentMailingListID != 0) {

    ; __line = 25
    ; __append("								</optgroup>\n")
    ; __line = 26
    ; 							}

    ; __line = 27
    ; __append("							<optgroup label=\"Mailingliste &quot;")
    ; __append(escapeFn( list[mailingListID].name ))
    ; __append("&quot;\">\n")
    ; __line = 28
    ; 							currentMailingListID = mailingListID;
}
for(j in (list[mailingListID] || {}).subscribers || []) {
subscriber = list[mailingListID].subscribers[j];

    ; __line = 32
    ; __append("							<option value=\"")
    ; __append(escapeFn( subscriber.subscriberID ))
    ; __append("\">")
    ; __append(escapeFn( subscriber.lastName ))
    ; __append(" ")
    ; __append(escapeFn( subscriber.firstName ))
    ; __append(" (")
    ; __append(escapeFn( subscriber.email ))
    ; __append(")</option>\n")
    ; __line = 33
    ; 						}
}
if (currentMailingListID>0) {

    ; __line = 36
    ; __append("						</optgroup>\n")
    ; __line = 37
    ; 					} 
    ; __append("\n</select>\n<select name=\"viewMode\">\n<option value=\"html\" selected>HTML-Version</option>\n<option value=\"text\">Text-Version</option>\n</select>\n<button type=\"button\" data-action=\"showMailing\" data-type=\"desktop\" data-target=\"iframe\">Desktop</button>\n<button type=\"button\" data-action=\"showMailing\" data-type=\"external\" data-target=\"window\">Neues Fenster / Tab</button>\n<button type=\"button\" data-action=\"showMailing\" data-type=\"downloadHtml\">Download Html</button>\n<button type=\"button\" data-action=\"sendMailing\" data-type=\"sendPreviewMail\">Vorschau E-Mail senden</button>\n</div>\n")
    ; __line = 48
    ; 	}
else {

    ; __line = 50
    ; __append("			<p>Es wurden noch keine Empfänger für den Vorschau-Modus definiert!</p>\n")
    ; __line = 51
    ; 	}

    ; __line = 52
    ; __append("\n</div>\n</div>\n<iframe class=\"desktop\" frameborder=\"0\"></iframe>\n</div>")
    ; __line = 56
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/mailings/edit/preview/preview.ejs

}